import { Component, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import { IUser } from "@/models/users";
import _ from "@/boot/lodash";
import { QUERY_PARAMS } from "@/data/constants";

interface IHash {
  isVerifying: boolean;
  isExpiredOrInvalid: boolean;
  passwordRequired: boolean;
  twoFARequired: boolean;
  twoFAProvider: IUser["provider_2fa_id"];
}

@Component
export default class HashVerificationMixin extends Mixins(Context) {
  // Data
  public username = _.get(
    this.$route.query,
    QUERY_PARAMS.USERNAME,
    ""
  ) as IUser["email"];

  public reg_hash = _.get(this.$route.query, QUERY_PARAMS.HASH, "") as string;

  public hash: IHash = {
    isVerifying: true,
    isExpiredOrInvalid: false,
    passwordRequired: false,
    twoFARequired: false,
    twoFAProvider: null
  };

  // Methods

  public async initHashVerification() {
    return new Promise<void>(resolve => {
      setTimeout(async () => {
        await this.verifyHash();
        this.hash.isVerifying = false;
        resolve();
      }, 1000);
    });
  }

  private async verifyHash() {
    try {
      // Check username and hash
      if (!this.username || !this.reg_hash)
        throw new Error(this.$t("_sentence.invalid_link") as string);
      // Verify hash
      const { data } = await this.$store.dispatch(
        this.isAdmin ? "auth/admin/verifyRegHash" : "auth/client/verifyRegHash",
        {
          username: this.username,
          reg_hash: this.reg_hash
        }
      );
      // Check if password is required
      this.hash.passwordRequired = !_.get(data, "has_password", false);
      // Check 2FA
      this.hash.twoFARequired = !!_.get(data, "twofa_enabled", false);
      this.hash.twoFAProvider = (
        _.get(data, "twofa_provider") || ""
      ).toLowerCase();
    } catch (error) {
      this.hash.isExpiredOrInvalid = true;
      this.$store.dispatch("api/handleError", error);
    }
  }
}
